module.exports = __webpack_public_path__ + "static/banner-one-shape10-89facd15e6226ea93c20e2faee70bfa2.png";